import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';
import { PAGE_DEFAULT_TEMPLATE, ORANGE_LENS_TYPE } from '../../../constants';
import { getOrangeLensProducts } from './orangeLens.utils';

export const orangeLens = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('orange-lens.page-load', ({ output }) => {
    const { categoryTitle, itemIds } = output;
    const parentBreadCrumbs = `${ORANGE_LENS_TYPE}>${categoryTitle} inspired by your image`;
    digitalData.page = {
      pageInfo: {
        abTest: '',
        pageName: parentBreadCrumbs,
        pageTemplate: PAGE_DEFAULT_TEMPLATE,
        pageType: ORANGE_LENS_TYPE
      },
      category: {
        primaryCategory: ORANGE_LENS_TYPE,
        subCategory1: ORANGE_LENS_TYPE,
        subCategory2: ORANGE_LENS_TYPE
      }
    };
    digitalData.content = {
      ...digitalData.content,
      product: getOrangeLensProducts(itemIds)
    };
    setAnalytics(digitalData);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('orange-lens.page-load-error', ({ output }) => {
    const {
      type,
      displayType,
      pageSection,
      message,
      code
    } = output;
    const pageName = `${ORANGE_LENS_TYPE}>no search results`;
    digitalData.content = {};
    digitalData.page = {
      error: [
        {
          type,
          displayType,
          pageSection,
          message,
          code
        }
      ],
      pageInfo: {
        abTest: '',
        pageName: pageName,
        pageTemplate: PAGE_DEFAULT_TEMPLATE,
        pageType: ORANGE_LENS_TYPE
      },
      category: {
        primaryCategory: ORANGE_LENS_TYPE,
        subCategory1: ORANGE_LENS_TYPE,
        subCategory2: ORANGE_LENS_TYPE
      }
    };
    setAnalytics(digitalData);
  });
};